import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";

interface SoundTestModalProps {
  open: boolean;
  onClose: () => void;
}

export const SoundTestModal = ({ open, onClose }: SoundTestModalProps) => (
  <Modal open={open} onClose={onClose}>
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#667eea",
      }}
    >
      <iframe
        src="https://kuri.rs/micrphone-speaker-tester.html"
        title="Microphone & Speaker Tester"
        style={{ flex: 11, width: "100%", border: "none", zIndex: 1111111111 }}
        allow="microphone; autoplay"
      />

      <div style={{ flex: 1, width: "100%" }}>
        <Button
          style={{
            width: "100%",
            height: "100%",
            fontSize: "3rem",
            fontWeight: "700",
            color: "white",
          }}
          onClick={onClose}
        >
          Back to Reception
        </Button>
      </div>
    </div>
  </Modal>
);
